import React from "react";

const securityPlanItems = [
  `<span style="font-weight: 700;">Basic Family Protection:</span> Add 10 adults and unlimited children for just $5/month`,
  `<span style="font-weight: 700;">Complete Individual Protection:</span> Upgrade to enhanced security with 3-bureau credit monitoring for just $10/month`,
  `<span style="font-weight: 700;">Complete Family Protection:</span> Get maximum security for your entire family for just $20/month`,
];

export const SecurityPlan = () => {
  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
      <div className="flex flex-col gap-8 md:flex-row sm:gap-10 md:gap-12 lg:gap-14 xl:gap-16 2xl:gap-20 w-full max-w-[82.3125rem] mx-auto py-5 sm:py-8 md:py-11 lg:py-[3.125rem]">
        <div className="flex flex-1 justify-center items-center md:order-2 md:justify-start">
          <div className="size-[17.5rem] sm:size-[20.5rem] md:size-[23.5rem] lg:size-[26.5rem] xl:size-[29.5rem] 2xl:size-[31.25rem] shrink-0 rounded-xl md:rounded-2xl overflow-hidden">
            <img
              src="/assets/standard-quality.webp"
              alt="standard Quality Control Concept"
              className="object-cover size-full"
            />
          </div>
        </div>
        <div className="md:order-1 flex justify-center md:justify-end items-center w-full max-w-[33.03125rem] md:max-w-[43.03125rem] mx-auto md:mx-0">
          <div className="space-y-6 sm:space-y-7 lg:space-y-8 w-full max-w-[42.5rem]">
            <div className="text-center md:text-left">
              <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
                Security Plan Upgrade Options
              </h2>
              <p className="max-w-[36.4375rem] text-[#64748B] text-sm sm:text-[0.935rem] lg:text-[1.0625rem] font-normal leading-5 sm:leading-[1.3125rem] lg:leading-[1.34375rem] tracking-[-0.01063rem] mx-auto lg:mx-0">
                All 3GB, 5GB, and 15GB plans include Basic Individual
                Protection, but can be easily upgraded:
              </p>
            </div>
            <ul className="space-y-3 sm:space-y-3.5 lg:space-y-4">
              {securityPlanItems.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2.5 sm:gap-3 lg:gap-4"
                >
                  <img
                    src="/assets/tick-circle-orange.svg"
                    alt="Tick"
                    className="size-5 sm:size-6 md:size-7 lg:size-8 shrink-0"
                  />
                  <p
                    className="text-[#1A0F33] text-sm sm:text-[0.925rem] lg:text-base font-medium leading-5 sm:leading-[1.3125rem] lg:leading-[1.4rem]"
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <span className="inline-block w-full text-center text-[#1D1D1B]/50 text-sm sm:text-base lg:text-lg font-medium leading-5 sm:leading-6 lg:leading-7 mx-auto">
        *Both security plans include 24/7 fraud resolution support
      </span>
    </section>
  );
};
